import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsP5DotJsComponent } from './simple-icons-p5-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsP5DotJsComponent ],
    exports:      [ SimpleIconsP5DotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsP5DotJsModule {}
